// extracted by mini-css-extract-plugin
export default {"checkbox":"AbstractProductEditStep6_checkbox__3Ja4h"};